import { render, staticRenderFns } from "./EditingAtractionsUniqnes.vue?vue&type=template&id=dca89d76&scoped=true"
import script from "./EditingAtractionsUniqnes.vue?vue&type=script&lang=js"
export * from "./EditingAtractionsUniqnes.vue?vue&type=script&lang=js"
import style0 from "./EditingAtractionsUniqnes.vue?vue&type=style&index=0&id=dca89d76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dca89d76",
  null
  
)

export default component.exports